module.exports = {
	RECEIVE_THEMES: 'RECEIVE_THEMES',
	SELECTED_THEMES: 'SELECTED_THEMES',
	SELECTED_FILTERS: 'SELECTED_FILTERS',
	ENTRY_FILTER: 'ENTRY_FILTER',
	RESET_SELECTED_THEMES: 'RESET_SELECTED_THEMES',
	RESET_SELECTED_FILTERS: 'RESET_SELECTED_FILTERS',
	RESET_ENTRY_FILTER: 'RESET_ENTRY_FILTER',
	RESET_ADMINISTRATION_STORE: 'RESET_ADMINISTRATION_STORE',
	RECEIVE_ALL_SOURCES: 'RECEIVE_ALL_SOURCES',
    RECEIVE_DATA_TYPE_STATISTICS: 'RECEIVE_DATA_TYPE_STATISTICS',
    RECEIVE_LEGENDS: 'RECEIVE_LEGENDS',
    ADD_LEGEND: 'ADD_LEGEND',
	REMOVE_LEGEND: 'REMOVE_LEGEND',
    READ_NEWS: 'READ_NEWS',
    RECEIVE_NEWS: 'RECEIVE_NEWS'
}



// WEBPACK FOOTER //
// ./src/administration/constants/AdministrationConstants.js